import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
    box: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        backgroundColor: "transparent",

        //        'border': '1px solid green',
    },
    boxPrancheta: {
        backgroundColor: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        width: "50vw;",
        height: "45vh",
        padding: "20px",
        //        'border': '1px solid blue',
    },
    side_content: {
        display: "grid",
        overflow: "auto",
    },
    header_grid: {
        backgroundColor: "black",
        color: "white",
    },
    input_data: {
        display: "flex",
        flexDirection: "column",
    },
    fab: {
        display: "inline",
        position: "absolute",
        bottom: "0px",
        right: "0",
        /*        border: '3px solid #73AD21',*/
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));
